// extracted by mini-css-extract-plugin
module.exports = {"component":"UsersFormPage_component__3HV4e","content":"UsersFormPage_content__jUZX8","header":"UsersFormPage_header__Uv36o"};